"use client"

import { useState, useContext, useEffect, useRef } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import { useParams } from "react-router-dom"
import { useTenantNavigation } from "../../hooks/useTenantNavigation"
import "./GestionDevolucionCanjeVenta.css"

import Cookies from "js-cookie";

// Material UI Components
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
  Autocomplete,
  Checkbox,
  Collapse,
  Modal,
  Divider,
  Tooltip,
  FormControlLabel,
  InputAdornment,
  Card,
  CardContent,
  Alert,
  Snackbar,
  useTheme,
  alpha,
} from "@mui/material"

// Material UI Icons
import {
  Close as CloseIcon,
  ErrorOutline as ErrorOutlineIcon,
  Visibility as VisibilityIcon,
  AddCircleOutline as AddCircleOutlineIcon,
  Delete as DeleteIcon,
  PersonAddAlt as PersonAddAltIcon,
  AddShoppingCart as AddShoppingCartIcon,
  Receipt as ReceiptIcon,
  Payments as PaymentsIcon,
  Person as PersonIcon,
  Search as SearchIcon,
  PointOfSale as PointOfSaleIcon,
  SwapHoriz as SwapHorizIcon,
  KeyboardReturn as KeyboardReturnIcon,
} from "@mui/icons-material"

// Components
import ModalEntidadCliente from "../adminComponent/ModalEntidadClienteComponent.js"
import CrearEntidadClienteModalComponent from "../adminComponent/CrearEntidadClienteModalComponent.js"
import ModalFacturaComponent from "./ModalFacturaComponent.js"
import SpinnerLading from "../misc/SpinnerComponent.js"

// Styled Table Components
import { styled } from "@mui/material/styles"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"

import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

// Styled table components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#5b5b5f",
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.1),
    transition: "background-color 0.2s ease",
  },
}))

const GestionDevolucionCanjeVentaComponent = () => {
  const theme = useTheme()
  const { idTransaccionDatosDevolucion } = useParams()
  const navigate = useTenantNavigation()

  const {
    getItemTresLetras,
    itemTresLetras,
    getEntidadesClientesTresLetras,
    postTransaccionItemDevolucion,
    postTransaccionDevolucion,
    entidades,
    getTipoEntidad,
    tipoMedioDePago,
    getTipoMedioDePago,
    updateItemUbicacion,
    postCrearPago,
    postTransaccionPago,
    getMedioDePagoIdTipoEspecifico,
    medioDePagoIdTipoEspecifico,
    getCuentaCorriente,
    getCuentaCorrienteByIdEntidad,
    postCuentaCorriente,
    updateCuentaCorriente,
    getUsuario,
    usuarios,
    getTransaccionFilter,
    getTransaccionItemsByTransactionId,
    getEntidadByID,
    getItemById,
    postTransaccion,
    getEntidadByDNI,
    arrayItemTresLetras,
    getUbicacion,
    ubicaciones,
    getNegocio,
    negocios,
    getItemUbicacionFilterByUbicacion,
    tenantContext,
    getListaMontosByIdItemIdEntidad,
    updateTransaccionItem,
    getTransaccionItemByTransactionAndItem, isNavbarCollapsed,
    user,
    validarDevolucionCanje,
    getTransaccionFacturadaData,
    generarNotaCredito,
    getImpuestoItem,
    getIvaAFIP,
    abrirNotaCreditoAfip,
  } = useContext(ErpContext)

  // Estados principales
  const [descripcionTransaccion, setDescripcionTransaccion] = useState("")
  const [selectedItem, setSelectedItem] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [searchTextCliente, setSearchTextCliente] = useState("")
  const [filteredItems, setFilteredItems] = useState([])
  const [itemList, setItemList] = useState([])
  const [transaccionItemFiltrados, setTransaccionItemFiltrados] = useState([])
  const [transaccionFiltrada, setTransaccionFiltrada] = useState([])
  const [itemListCanjeables, setItemListCanjeables] = useState([])
  const [cantidadTransaccionItem, setCantidadTransaccionItem] = useState("")
  const [dniCliente, setDniCliente] = useState("")
  const [idEntidad, setIdEntidad] = useState("")
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState([])
  const [entidadFiltrada, setEntidadFiltrada] = useState([])

  // Estados para precios y cantidades
  const [precioTotal, setPrecioTotal] = useState(0)
  const [precioTotalNetoDevolucion, setPrecioTotalNetoDevolucion] = useState(0)
  const [precioTotalDevolucion, setPrecioTotalDevolucion] = useState(0)
  const [precioTotalDevolucionDiferencia, setPrecioTotalDevolucionDiferencia] = useState(0)
  const [totalInteresCanje, setTotalInteresCanje] = useState(0)
  const [totalInteresDevolucion, setTotalInteresDevolucion] = useState(0)
  const [cantidadItemsSelect, setCantidadItemsSelect] = useState(0)
  const [cantidadItemsInvocados, setCantidadItemsInvocados] = useState(0)

  // Estados para entidades y clientes
  const [entidadExistente, setEntidadExistente] = useState(null)
  const [abrirModalCrearCliente, setAbrirModalCrearCliente] = useState(false)
  const [abrirModalEntidadCliente, setAbrirModalEntidadCliente] = useState(false)
  const [entidadAEditar, setEntidadAEditar] = useState(null)
  const [isEditing, setIsEditing] = useState(false)

  // Estados para descuentos
  const [valorDescuento, setValorDescuento] = useState(0)
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0)
  const [tempValorDescuento, setTempValorDescuento] = useState("0")
  const [tempPorcentajeDescuento, setTempPorcentajeDescuento] = useState("0")
  const [precioBaseTotal, setPrecioBaseTotal] = useState(0)
  const [aplicarDescuento, setAplicarDescuento] = useState(false)

  // Estados para modales
  const [openModal, setOpenModal] = useState(false)
  const [openModalMedioPago, setOpenModalMedioPago] = useState(false)
  const [transaccionData, setTransaccionData] = useState(null)
  const [itemsTransaccion, setItemsTransaccion] = useState({
    itemList: [],
    itemListCanjeables: []
  });
  const [entidadFactura, setEntidadFactura] = useState([])

  // Estados para medios de pago
  const [modalMedioDePagoSeleccionadoID, setModalMedioDePagoSeleccionadoID] = useState(null)
  const [modalTipoMedioDePagoSeleccionado, setModalTipoMedioDePagoSeleccionado] = useState(null)
  const [modalMedioDePagoSeleccionado, setModalMedioDePagoSeleccionado] = useState(null)
  const [modalMedioDePagoCantidad, setModalMedioDePagoCantidad] = useState(null)
  const [medioDePagoList, setMedioDePagoList] = useState([])
  const [cantidaMedioDePagoList, setCantidaMedioDePagoList] = useState(0)
  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState(null)
  const [selectedMedioDePago, setSelectedMedioDePago] = useState([])
  const [openCollapse, setOpenCollapse] = useState(false)
  const [mostrarButtonModalMedioPago, setMostrarButtonModalMedioPago] = useState(false)

  // Otros estados
  const [impuestos, setImpuestos] = [{}]
  const [filteredTransaccionItems, setFilteredTransaccionItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const [selectedNegocio, setSelectedNegocio] = useState(null)
  const [cantidadInputs, setCantidadInputs] = useState({});
  const [cantidadInputsDevueltos, setCantidadInputsDevueltos] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  })

  // Cada vez que itemList cambie, inicializamos el string a partir de la cantidad numérica
  useEffect(() => {
    const init = {};
    itemList.forEach((it, i) => {
      init[i] = it.cantidad.toString();
    });
    setCantidadInputs(init);
  }, [itemList]);

  useEffect(() => {
    const init = {};
    itemListCanjeables.forEach((it, i) => {
      init[i] = it.cantidadDevolver.toString();
    });
    setCantidadInputsDevueltos(init);
  }, [itemListCanjeables]);

  // Referencias
  const autocompleteRef = useRef(null)
  const cantidadRef = useRef(null)
  const buttonRef = useRef(null)

  const getNumericValue = (value) => Number(value) || 0

  const getDiscountFactor = (item) => 1 - getNumericValue(item?.porcentajeDescuento) / 100

  const getInterestPercent = (item) => getNumericValue(item?.porcentajeInteres)

  const getInterestFactor = (item) => 1 + getInterestPercent(item) / 100

  const getSubtotalConDescuento = (item, cantidad) =>
    getNumericValue(item?.precio) * getNumericValue(cantidad) * getDiscountFactor(item)

  const getInteresItem = (item, cantidad) =>
    getSubtotalConDescuento(item, cantidad) * (getInterestPercent(item) / 100)

  const getTotalItemConInteres = (item, cantidad) =>
    getSubtotalConDescuento(item, cantidad) * getInterestFactor(item)

  // En la grilla de devueltos mostramos total de referencia:
  // usa cantidad original y, si el usuario cargó devolución, usa esa cantidad.
  const getCantidadReferenciaDevolucion = (item) => {
    const cantidadDevolver = getNumericValue(item?.cantidadDevolver)
    return cantidadDevolver > 0 ? cantidadDevolver : getNumericValue(item?.cantidad)
  }

  const aplicarDescuentoGlobal = (totalBase) => {
    let totalConDescuento = totalBase
    const valorDesc = Number.parseFloat(tempValorDescuento) || 0
    const porcentajeDesc = Number.parseFloat(tempPorcentajeDescuento) || 0

    if (valorDesc > 0) {
      totalConDescuento -= valorDesc
    }

    if (porcentajeDesc > 0) {
      totalConDescuento -= (totalConDescuento * porcentajeDesc) / 100
    }

    return Math.max(totalConDescuento, 0)
  }

  // Efecto para cargar datos de transacción
  useEffect(() => {
    const fetchData = async () => {
      if (idTransaccionDatosDevolucion) {
        try {
          const transaccionFiltrada = await getTransaccionFilter(idTransaccionDatosDevolucion)

          const EntidadFiltrada = await getEntidadByID(transaccionFiltrada.idEntidad)
          setIdEntidad(EntidadFiltrada)

          // *HARDCODED*
          await getUbicacion()
          await getNegocio()

          // Configurar la ubicación predeterminada
          const defaultUbicacion = ubicaciones.find((it) => it.id === transaccionFiltrada.idUbicacion)
          const defaultNegocio = negocios.find((it) => it.id === transaccionFiltrada.idNegocio)

          if (defaultUbicacion) {
            setSelectedUbicacion({
              id: defaultUbicacion.id,
              label: defaultUbicacion.descripcion,
            })
          }
          if (setSelectedNegocio) {
            setSelectedNegocio({
              id: defaultNegocio.id,
              label: defaultNegocio.descripcion,
            })
          }

          setDniCliente(EntidadFiltrada.dniCuitCuil)
          setPrecioTotalDevolucion(transaccionFiltrada.montoTotal)

          const transaccionItemFiltrados = await getTransaccionItemsByTransactionId(idTransaccionDatosDevolucion)

          // Mapeo asíncrono usando Promise.all
          const mappedItems = await Promise.all(
            transaccionItemFiltrados.map(async (filteredItem) => {
              const itemById = await getItemById(filteredItem.idItem)

              // Obtener información de impuestos del item (igual que en GestionGenerarVentaComponent)
              const itemImpuesto = await getImpuestoItem(filteredItem.idItem, transaccionFiltrada.idUbicacion);
              const itemIvaPercentage = itemImpuesto?.porcentaje || 21;
              const impuestosAFIP = getIvaAFIP();
              const impuestoAFIPCoincidente = impuestosAFIP.find(imp =>
                Math.abs(imp.porcentaje - itemIvaPercentage) < 0.01
              );

              return {
                ...filteredItem,
                descripcion: itemById?.descripcion || "Descripción no disponible",
                codigo: itemById?.codigo || "Código no disponible",
                cantidadDevolver: 0,
                idUbicacion: transaccionFiltrada.idUbicacion,
                // Información de impuestos para cálculo de NC
                impuestoData: {
                  idImpuesto: impuestoAFIPCoincidente?.id || itemImpuesto?.idImpuesto || null,
                  porcentaje: itemIvaPercentage,
                  descripcionImpuesto: impuestoAFIPCoincidente?.descripcion || itemImpuesto?.descripcionImpuesto || "IVA General",
                  idIva: impuestoAFIPCoincidente?.idIva || 1,
                },
                ivaPercentage: itemIvaPercentage
              }
            }),
          )

          setItemListCanjeables(mappedItems)
          setFilteredTransaccionItems(mappedItems)
        } catch (error) {
          console.error("Error al cargar los datos de la transacción:", error)
          showSnackbar("Error al cargar los datos de la transacción", "error")
        } finally {
          setLoading(false)
        }
      }
    }

    fetchData()
  }, [idTransaccionDatosDevolucion])

  // Efecto para actualizar totales
  useEffect(() => {
    if (idTransaccionDatosDevolucion) {
      updateTotals(filteredTransaccionItems)
    } else {
      updateTotals(itemList)
    }
  }, [itemList, filteredTransaccionItems])

  // Función para actualizar totales
  const updateTotals = (items) => {
    const updatedTotal = items.reduce(
      (total, item) => total + getTotalItemConInteres(item, item.cantidad),
      0,
    )

    setPrecioBaseTotal(updatedTotal)
  }

  // Efecto para cargar usuario por defecto
  useEffect(() => {
    const idUsuarioGuardado = Cookies.get("idUsuario");
    if (idUsuarioGuardado && usuarios.length > 0) {
      const usuarioDefault = usuarios.find(
        (user) => user.id === Number.parseInt(idUsuarioGuardado, 10)
      );
      if (usuarioDefault) {
        setUsuarioSeleccionado({
          label: `${usuarioDefault.usuario} ${usuarioDefault.nombre || ""} ${usuarioDefault.apellido || ""
            }`,
          ...usuarioDefault,
        });
      }
    }
  }, [usuarios]);

  // Efecto para manejar medios de pago
  useEffect(() => {
    if (selectedTipoMedioDePago) {
      if (selectedTipoMedioDePago.id === 7) {
        setOpenCollapse(false)
        setMostrarButtonModalMedioPago(true)
        setOpenModalMedioPago(true)
      } else {
        getMedioDePagoIdTipoEspecifico(selectedTipoMedioDePago)
        setMostrarButtonModalMedioPago(false)
        setOpenCollapse(true)
      }
    } else {
      setOpenCollapse(false)
      setOpenModalMedioPago(false)
      setMedioDePagoList([])
    }

    if (modalTipoMedioDePagoSeleccionado) {
      getMedioDePagoIdTipoEspecifico(modalTipoMedioDePagoSeleccionado)
    }
  }, [selectedTipoMedioDePago, modalTipoMedioDePagoSeleccionado])

  // Efecto para búsqueda de ítems
  useEffect(() => {
    if (searchText.length >= 3) {
      arrayItemTresLetras([])
      getItemTresLetras(searchText)
    } else {
      arrayItemTresLetras([])
      setFilteredItems([])
    }
  }, [searchText])

  // Efecto para búsqueda de clientes
  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, 1)
    } else {
      setFilteredItems([])
    }
  }, [searchTextCliente])

  // Efecto para cargar datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTipoEntidad()
        await getTipoMedioDePago()
        await getUsuario()
      } catch (error) {
        console.error("Error al cargar los datos:", error)
        showSnackbar("Error al cargar los datos iniciales", "error")
      }
    }

    fetchData()
  }, [])

  // Efecto para actualizar el total
  useEffect(() => {
    const updatedTotal = itemList.reduce(
      (total, item) => total + getTotalItemConInteres(item, item.cantidad),
      0,
    )
    setPrecioBaseTotal(updatedTotal)
    setPrecioTotal(aplicarDescuentoGlobal(updatedTotal))
  }, [itemList, tempValorDescuento, tempPorcentajeDescuento])

  // Efecto para resetear descuentos
  useEffect(() => {
    if (aplicarDescuento == false) {
      setTempValorDescuento(0)
      setTempPorcentajeDescuento(0)
    }
  }, [aplicarDescuento])

  // Efecto para calcular neto de devolución
  useEffect(() => {
    const updatedTotalCanjeBruto = itemList.reduce(
      (total, item) => total + getTotalItemConInteres(item, item.cantidad),
      0,
    )
    const updatedTotalCanjeNeto = aplicarDescuentoGlobal(updatedTotalCanjeBruto)
    const updatedTotalDevolucion = itemListCanjeables.reduce(
      (total, item) => total + getTotalItemConInteres(item, item.cantidadDevolver),
      0,
    )
    const updatedInteresCanje = itemList.reduce(
      (total, item) => total + getInteresItem(item, item.cantidad),
      0,
    )
    const updatedInteresDevolucion = itemListCanjeables.reduce(
      (total, item) => total + getInteresItem(item, item.cantidadDevolver),
      0,
    )

    setPrecioTotalNetoDevolucion(updatedTotalCanjeNeto - updatedTotalDevolucion)
    setPrecioTotalDevolucionDiferencia(updatedTotalDevolucion)
    setTotalInteresCanje(updatedInteresCanje)
    setTotalInteresDevolucion(updatedInteresDevolucion)
  }, [itemList, itemListCanjeables, tempValorDescuento, tempPorcentajeDescuento])

  // Función para abrir modal de medio de pago
  const handleAbrirModalMedioDePago = () => {
    setOpenModalMedioPago(true)
  }

  // Función para agregar nuevo medio de pago
  const handleAddNuevoMedioDePago = () => {
    if (modalMedioDePagoSeleccionado && modalMedioDePagoCantidad) {
      const newMedioDePago = {
        id: modalMedioDePagoSeleccionadoID,
        descripcion: modalMedioDePagoSeleccionado,
        monto: Number.parseFloat(modalMedioDePagoCantidad),
        tipoMedioDePago: modalTipoMedioDePagoSeleccionado.id,
      }

      setMedioDePagoList([...medioDePagoList, newMedioDePago])

      const updatedTotalMedioPagoList = [...medioDePagoList, newMedioDePago].reduce(
        (total, item) => total + item.monto,
        0,
      )

      setCantidaMedioDePagoList(updatedTotalMedioPagoList)
      setModalMedioDePagoSeleccionado("")
      setModalMedioDePagoSeleccionadoID(null)
      setModalMedioDePagoCantidad("")

      showSnackbar("Medio de pago agregado", "success")
    } else {
      showSnackbar("Debe seleccionar un medio de pago y especificar un monto", "warning")
    }
  }

  // Función para eliminar medio de pago
  const handleDeleteMedioDePago = (medioDePago, medioDePagoMonto) => {
    setCantidaMedioDePagoList((prevTotal) => prevTotal - medioDePagoMonto)
    setMedioDePagoList(medioDePagoList.filter((_, i) => i !== medioDePago))

    showSnackbar("Medio de pago eliminado", "info")
  }

  // Función para aplicar descuentos
  const applyDiscounts = () => {
    const valorDesc = Number.parseFloat(tempValorDescuento) || 0
    const porcentajeDesc = Number.parseFloat(tempPorcentajeDescuento) || 0

    const totalConDescuento = aplicarDescuentoGlobal(precioBaseTotal)

    setPrecioTotal(totalConDescuento)
    setValorDescuento(valorDesc)
    setPorcentajeDescuento(porcentajeDesc)
  }

  // Función para enviar transacción
  const handleTransaccionSubmit = async (leerCliente) => {
    let entidadEncontrada = {}
    try {
      // VALIDACIÓN DE DEVOLUCIÓN ANTES DE PROCESAR
      if (idTransaccionDatosDevolucion && itemListCanjeables.length > 0) {
        try {
          const resultadoValidacion = await validarDevolucionCanje(
            idTransaccionDatosDevolucion,
            itemListCanjeables
          );
          
          if (!resultadoValidacion.valido) {
            // Mostrar popup de error con detalles
            mostrarErrorValidacion(resultadoValidacion.errores);
            return;
          }
        } catch (error) {
          console.error("Error en validación:", error);
          showSnackbar("Error al validar la devolución", "error");
          return;
        }
      }

      // VERIFICAR SI LA TRANSACCIÓN ORIGINAL FUE FACTURADA Y GENERAR NOTA DE CRÉDITO SI CORRESPONDE
      let datosFacturaOriginal = null;
      if (idTransaccionDatosDevolucion && precioTotalNetoDevolucion < 0) {
        try {
          datosFacturaOriginal = await getTransaccionFacturadaData(idTransaccionDatosDevolucion);
          
          if (datosFacturaOriginal.fueFacturada) {
            console.log("La transacción original fue facturada, se generará nota de crédito");
            console.log("Datos de la factura original:", datosFacturaOriginal.facturaOriginal);
            
            // Preparar datos para la Nota de Crédito
            const facturaOriginal = datosFacturaOriginal.facturaOriginal;
            
            // Calcular importes para la NC (todos positivos)
            const impNeto = Math.abs(precioTotalDevolucion);
            const impIva = Math.abs(precioTotalDevolucionDiferencia);
            const impTotal = impNeto + impIva;
            
            // Preparar datos de la factura original para el context
            const datosFacturaOriginalParaNC = {
              tipoFacturaAFIP: facturaOriginal.tipoFacturaAFIP,
              ptoVta: facturaOriginal.ptoVta,
              nroFactura: facturaOriginal.numeroFactura
            };
            
            // Preparar datos de la devolución
            const datosDevolucion = {
              montoTotal: impTotal,
              montoNeto: impNeto,
              montoIVA: impIva,
              condicionIVA: 5, // Por defecto Consumidor Final
              iva: impIva > 0 ? [{
                Id: 5, // 21%
                BaseImp: impNeto,
                Importe: impIva
              }] : [],
              items: itemListCanjeables.map(item => ({
                codigo: item.codigo,
                descripcion: item.descripcion,
                cantidad: item.cantidadDevolver, // Usar cantidadDevolver en lugar de cantidad
                precio: item.precio,
                importe: item.cantidadDevolver * item.precio, // Calcular importe basado en cantidad a devolver
                impuestoData: item.impuestoData, // Incluir información de impuestos
                ivaPercentage: item.ivaPercentage
              })),
              // ✅ Agregar idTransaccion que se necesita para guardar en TransaccionTipoFactura
              idTransaccion: null, // Se asignará después de crear la transacción de devolución
              direccionCliente: '',
              condicionVenta: selectedTipoMedioDePago?.descripcion || 'CONTADO',
              condicionIvaDescripcion: '',
              telefonoCliente: '',
              emailCliente: '',
              localidadCliente: '',
              provinciaCliente: ''
            };
            
            // Preparar datos del cliente - usar entidadFactura si está disponible
            let entidadCliente = null;
            if (entidadFactura && entidadFactura.length > 0) {
              entidadCliente = {
              dniCuitCuil: entidadFactura[0].dniCuitCuil,
              descripcion: `${entidadFactura[0].descripcion} ${entidadFactura[0].apellido || ''}`.trim(),
              direccion: entidadFactura[0].direccion || '',
              telefono: entidadFactura[0].telefono || entidadFactura[0].celular || '',
              email: entidadFactura[0].email || '',
              condicionIvaDescripcion: entidadFactura[0].condicionIvaDescripcion || entidadFactura[0].condicionIVA || '',
              localidad: entidadFactura[0].localidad || '',
              provincia: entidadFactura[0].provincia || ''
            };
            } else if (dniCliente) {
              // Buscar la entidad por DNI si no tenemos entidadFactura
              try {
                const entidadEncontrada = await getEntidadByDNI(dniCliente);
                if (entidadEncontrada) {
                  entidadCliente = {
                    dniCuitCuil: entidadEncontrada.dniCuitCuil,
                    descripcion: `${entidadEncontrada.descripcion} ${entidadEncontrada.apellido || ''}`.trim(),
                    direccion: entidadEncontrada.direccion || '',
                    telefono: entidadEncontrada.telefono || entidadEncontrada.celular || '',
                    email: entidadEncontrada.email || '',
                    condicionIvaDescripcion: entidadEncontrada.condicionIvaDescripcion || entidadEncontrada.condicionIVA || '',
                    localidad: entidadEncontrada.localidad || '',
                    provincia: entidadEncontrada.provincia || ''
                  };
                }
              } catch (error) {
                console.error("Error al buscar entidad:", error);
              }
            }
            
            // Si no tenemos datos del cliente, usar datos por defecto
            if (!entidadCliente) {
              entidadCliente = {
                dniCuitCuil: '',
                descripcion: 'Consumidor Final',
                direccion: '',
                telefono: '',
                email: '',
                condicionIvaDescripcion: 'Consumidor Final',
                localidad: '',
                provincia: ''
              };
            }
            
            datosDevolucion.direccionCliente = entidadCliente.direccion || "";
            datosDevolucion.condicionIvaDescripcion = entidadCliente.condicionIvaDescripcion || datosDevolucion.condicionIvaDescripcion || "";
            datosDevolucion.telefonoCliente = entidadCliente.telefono || "";
            datosDevolucion.emailCliente = entidadCliente.email || "";
            datosDevolucion.localidadCliente = entidadCliente.localidad || datosDevolucion.localidadCliente || "";
            datosDevolucion.provinciaCliente = entidadCliente.provincia || datosDevolucion.provinciaCliente || "";
            console.log("Datos preparados para NC:");
            console.log("- Factura Original:", datosFacturaOriginalParaNC);
            console.log("- Datos Devolución:", datosDevolucion);
            console.log("- Entidad Cliente:", entidadCliente);
            
            // ✅ Guardar datos para generar NC después de crear la transacción de devolución
            window.datosParaNC = {
              datosFacturaOriginalParaNC,
              datosDevolucion,
              entidadCliente
            };
          }
        } catch (error) {
          console.error("Error al verificar datos de facturación:", error);
          showSnackbar("Error al verificar si la transacción fue facturada", "error");
          return;
        }
      }

      if (leerCliente === true) {
        if (dniCliente) {
          entidadEncontrada = await getEntidadByDNI(dniCliente)
          setEntidadFactura(entidadEncontrada)
        } else {
          setEntidadExistente(null)
          setAbrirModalEntidadCliente(true)
          return
        }
      } else {
        dniCliente.id = null
      }

      console.log("selectedMedioDePago: ", selectedMedioDePago)

      if (
        (
          (!selectedMedioDePago || selectedMedioDePago.length === 0) ||
          !selectedTipoMedioDePago
        ) &&
        medioDePagoList.length === 0
      ) {
        showSnackbar("Falta agregar un medio de pago", "error");
        setLoading(false);
        return;
      }

      //Verifica el id de la entidad con el dni ingresado. Por el momento no le veo utilidad a esto, puede simplementer no pedirse

      console.log("entidadEncontrada ", entidadEncontrada)
      // Crear la transacción de devolucion, por eso va el id 6. Lo raro es que es lo mismo que mandar transaccion por lo tanto no se si es necesario usar esto. Aunque se le puede relacionar una transaccion en transaccion asociada del modelo.

      console.log('se ejecuto postTransaccionDevolucion 1 vez')
      const transaccionResponse = await postTransaccionDevolucion(
        precioTotalNetoDevolucion,
        6,
        entidadEncontrada.id,
        null,
        descripcionTransaccion,
        usuarioSeleccionado.id,
        selectedUbicacion.id,
        selectedNegocio.id,
        idTransaccionDatosDevolucion, //Creo que seria la transaccion asociada
        tempValorDescuento,
        tempPorcentajeDescuento,
      )

      const idTransaccion = transaccionResponse.data.id //id de la transaccion devolucion recien creada

      const precioTotalNetoModificadoParaIngresoEgreso = precioTotalNetoDevolucion //Esta variable es la diferencia entre transaccion monto total, devuelvos y canjeados
      let transaccionResponseIngresoEgreso = {}

      if (precioTotalNetoModificadoParaIngresoEgreso > 0) { //En este caso va un egreso porque le debemos plata al tipo por las devoluciones de los items
        transaccionResponseIngresoEgreso = await postTransaccion(
          precioTotalNetoModificadoParaIngresoEgreso,
          4,
          entidadEncontrada.id,
          null,
          `Se le pago al cliente la diferencia por la devolucion de productos referida a la transaccion: ${idTransaccion}`,
          usuarioSeleccionado.id,
          selectedUbicacion.id,
          selectedNegocio.id,
          tempValorDescuento,
          tempPorcentajeDescuento,
          idTransaccionDatosDevolucion,
        )
      }

      if (precioTotalNetoModificadoParaIngresoEgreso < 0 && selectedTipoMedioDePago.id != 5) { //En este caso va un ingreso porque el cliente nos debe plata por supuestos canjes probablemente
        transaccionResponseIngresoEgreso = await postTransaccion(
          precioTotalNetoModificadoParaIngresoEgreso,
          5,
          entidadEncontrada.id,
          null,
          `El cliente pago la diferencia de un canje por devolucion de productos referida a la transaccion: ${idTransaccion}`,
          usuarioSeleccionado.id,
          selectedUbicacion.id,
          selectedNegocio.id,
          tempValorDescuento,
          tempPorcentajeDescuento,
          idTransaccionDatosDevolucion,
        )
      }

      const idTransaccionIngresoEgreso = transaccionResponseIngresoEgreso.data
        ? transaccionResponseIngresoEgreso.data.id
        : null

      if (selectedTipoMedioDePago.id == 7) { //ESTO ES LOGICA DE DINERO, DEPENDIENDO DEL TIPO DE MEDIO DE PAGO PASAN COSAS
        for (const it of medioDePagoList) {
          const transaccionCrearPago = await postCrearPago(1, 1, it.id, it.monto)

          // Verificar si el tipo de medio de pago afecta cuenta corriente usando el flag
          const tipoMedio = tipoMedioDePago.find(t => t.id === it.tipoMedioDePago)
          if (tipoMedio?.afectaCuentaCorriente === true) {
            const cuentas = await getCuentaCorrienteByIdEntidad(entidadEncontrada.id)
            const cuentaCorrienteConId = cuentas.find((ct) => ct.idEntidad === entidadEncontrada.id)
            if (cuentaCorrienteConId) {
              await updateCuentaCorriente(entidadEncontrada.id, it.monto, 2)
            } else {
              await postCuentaCorriente(entidadEncontrada.id, it.monto, 2)
            }
          }

          const idTransaccionCrearPago = transaccionCrearPago.data.id
          const transaccionPagoResponse = await postTransaccionPago(idTransaccionIngresoEgreso, idTransaccionCrearPago)
        }
      } else {
        const transaccionCrearPago = await postCrearPago(1, 1, selectedMedioDePago.id, precioTotalNetoDevolucion)

        if (selectedTipoMedioDePago.id == 5) {
          const cuentas = await getCuentaCorrienteByIdEntidad(entidadEncontrada.id)
          const cuentaCorrienteConId = cuentas.find((ct) => ct.idEntidad === entidadEncontrada.id)
          if (precioTotalNetoDevolucion > 0) {
            if (cuentaCorrienteConId) {
              await updateCuentaCorriente(entidadEncontrada.id, precioTotalNetoDevolucion, 1)
            } else {
              await postCuentaCorriente(entidadEncontrada.id, precioTotalNetoDevolucion, 1)
            }
          } else {
            if (cuentaCorrienteConId) {
              await updateCuentaCorriente(entidadEncontrada.id, precioTotalNetoDevolucion, 2)
            } else {
              await postCuentaCorriente(entidadEncontrada.id, precioTotalNetoDevolucion, 2)
            }
          }
        }
        const idTransaccionCrearPago = transaccionCrearPago.data.id

        if (precioTotalNetoModificadoParaIngresoEgreso != 0) {
          const responseTransaccionPago = await postTransaccionPago(
            idTransaccion,
            idTransaccionCrearPago,
          )
          const resposeTransaccionPagoDevolucion = await postTransaccionPago(
            idTransaccionIngresoEgreso,
            idTransaccionCrearPago,
          )
        }
      }


      for (const it of itemListCanjeables) {
        console.log('itemListCanjeables ', it)
        if (it.cantidadDevolver > 0) { //Si la cantidad a devolver es mayor a 0
          await postTransaccionItemDevolucion( //CREO QUE A ESTE LO USA PARA DESPUES RELACIONARLO A LA DEVOLUCION DE DEVUELTOS DEL MODAL. PARA MOSTRAR CANJEADOS Y DEVUELTOS
            idTransaccion,
            it.idItem,
            it.cantidadDevolver, //Se crea la transaccion con la cantidad a devolver (antes estaba .cantidad, quizas esta mal)
            it.precio,
            it.porcentajeDescuento,
            "-",
          )


          let nuevoStock = it.cantidadDevolver //Se suma la cantidad a devolver

          if (nuevoStock < 0) {
            console.log(`Stock insuficiente para ${it.descripcion}`)
            continue
          }

          await updateItemUbicacion(it.idItem, it.idUbicacion, nuevoStock, "compra")  //Se suma del stock con Compra

        }

      }

      // Crear los ítems asociados a la transacción
      if (itemList.length > 0) { // Si hay ítems en la lista de la transaccion que trajimos
        for (const it of itemList) {
          console.log('itemList ', it)
          if (it.cantidad > 0) {


            await postTransaccionItemDevolucion(
              idTransaccion,
              it.idItem,
              it.cantidad,
              it.precio,
              it.porcentajeDescuento,
              "+",
            )  //Aca lo que sucede es que se hace transaccion de canje, por eso el +. Se le asigna la cantidad a devolver y se le suma el precio y el porcentaje de descuento. No se si es necesario esto porque existe postTransaccionItem... pero bueno se creo hace mucho esto



            const nuevoStock = it.cantidad

            if (nuevoStock < 0) {
              console.log(`Stock insuficiente para ${it.descripcion}`)
              continue
            }

            await updateItemUbicacion(it.idItem, it.idUbicacion, nuevoStock, "venta") //Se resta del stock con venta
          }

        }
      }


      let medioDePagoPDF = [];

      if (selectedTipoMedioDePago.id != 7) {
        const newMedioDePago = {
          id: selectedMedioDePago.id,
          descripcion: selectedMedioDePago.descripcion,
          monto: precioTotalNetoModificadoParaIngresoEgreso,
          tipoMedioDePago: selectedMedioDePago.idTipoMedioDePago,
        };

        medioDePagoPDF = newMedioDePago;
      } else {
        medioDePagoPDF = medioDePagoList;
      }


      const transaccionData = {
        id: idTransaccion,
        cliente: entidadEncontrada.descripcion,
        pagos: medioDePagoPDF,
        tipoMedioDePago: medioDePagoList,
        montoDescuento: tempValorDescuento,
        porcentajeDescuento: tempPorcentajeDescuento,
        fecha: new Date().toLocaleDateString(),
      }
      setTransaccionData(transaccionData)
      setItemsTransaccion({
        itemList: itemList,
        itemListCanjeables: itemListCanjeables
      })

      // ✅ Generar Nota de Crédito si hay datos guardados
      if (window.datosParaNC) {
        try {
          // Actualizar el idTransaccion en datosDevolucion
          window.datosParaNC.datosDevolucion.idTransaccion = idTransaccion;
          
          console.log("Generando Nota de Crédito con idTransaccion:", idTransaccion);
          const resultadoNC = await generarNotaCredito(
            window.datosParaNC.datosFacturaOriginalParaNC,
            window.datosParaNC.datosDevolucion,
            window.datosParaNC.entidadCliente
          );
          console.log("Nota de Crédito generada exitosamente:", resultadoNC);
          
          // ✅ Generar y guardar PDF AFIP de Nota de Crédito
          showSnackbar(`Nota de Crédito generada: CAE ${resultadoNC.cae}`, "success");
          
          // Limpiar datos temporales
          delete window.datosParaNC;
        } catch (error) {
          console.error("Error al generar Nota de Crédito:", error);
          showSnackbar("Error al generar la Nota de Crédito", "error");
          // Limpiar datos temporales incluso si hay error
          delete window.datosParaNC;
        }
      }

      // Abrir el modal
      setOpenModal(true)

      // Resetear estados
      setSelectedItem(null)
      setSearchText("")
      setCantidadTransaccionItem("")
      setItemList([])
      setDniCliente("")
      setValorDescuento(0)
      setPorcentajeDescuento(0)
      setTempValorDescuento("0")
      setTempPorcentajeDescuento("0")
      setPrecioBaseTotal(0)
      setAplicarDescuento(false)
      setItemListCanjeables([])
      setTotalInteresCanje(0)
      setTotalInteresDevolucion(0)

      showSnackbar("Transacción creada correctamente", "success")
    } catch (error) {
      if (error.response) {
        console.error("Error en la respuesta del servidor:", error.response.data)
      } else if (error.request) {
        console.error("Error en la solicitud:", error.request)
      } else {
        console.error("Error en la configuración:", error.message)
      }
      showSnackbar("Error al procesar la transacción", "error")
    }
  }

  // Función para cerrar modal
  const handleCloseModal = () => {
    setOpenModal(false)
    navigate(`tablaVentas`)
  }

  // Función para crear venta sin cliente
  const crearVentaIgualmente = () => {
    handleTransaccionSubmit(false)
  }

  // Función para agregar ítem
  const handleAddItem = () => {
    const fetchData = async () => {
      if (selectedItem && cantidadTransaccionItem) {
        try {

          const ubicacionItem = await getItemUbicacionFilterByUbicacion(selectedItem.id, selectedUbicacion.id)

          const precioListaItem = await getListaMontosByIdItemIdEntidad(
            idEntidad.id,
            selectedItem.id,
            selectedUbicacion.id,
          )

          const stockDisponible = ubicacionItem ? ubicacionItem[0].inventario : "No disponible"
          // const precioItem = ubicacionItem ? ubicacionItem[0].precio : "No disponible"
          const precioItem = precioListaItem ? precioListaItem.monto : ubicacionItem[0].precio

          if (stockDisponible == "No disponible" || precioItem == "No disponible") {
            ProductoNoEncontrado()
            return
          }

          // Normalizar cantidad a máximo 4 decimales
          const cantidadParsed = Number.parseFloat(cantidadTransaccionItem);
          const cantidadNormalizada = isNaN(cantidadParsed) || cantidadParsed <= 0 
            ? 0 
            : Math.round(cantidadParsed * 10000) / 10000;

          const newItem = {
            descripcion: selectedItem.descripcion,
            cantidad: cantidadNormalizada,
            stock: stockDisponible,
            precio: precioItem,
            codigo: selectedItem.codigo,
            porcentajeDescuento: 0,
            porcentajeInteres: 0,
            idItem: ubicacionItem[0].idItem,
            idUbicacion: selectedUbicacion.id,
          }

          const updatedItems = [...itemList, newItem]

          // Recalcula el precio total
          const updatedTotal = updatedItems.reduce((total, item) => total + item.cantidad * item.precio, 0)

          // Recalcula la cantidad total de ítems seleccionados
          const updatedCantidadItem = updatedItems.reduce((cantidadItems, item) => cantidadItems + item.cantidad, 0)

          setPrecioTotal(updatedTotal)
          setCantidadItemsSelect(updatedCantidadItem)
          setItemList(updatedItems)
          setCantidadItemsInvocados(updatedItems.length)

          // Resetea los campos
          setSelectedItem(null)
          setCantidadTransaccionItem("")

          showSnackbar(`Ítem "${selectedItem.descripcion}" agregado`, "success")

          if (autocompleteRef.current) {
            autocompleteRef.current.focus()
          }
        } catch (error) {
          console.error("Error al cargar los datos de la transacción:", error)
          showSnackbar("Error al agregar el ítem", "error")
        }
      }
    }
    fetchData()
  }

  // Función para mostrar alerta de producto no encontrado
  const ProductoNoEncontrado = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error",
      text: "Producto no encontrado",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  // Función para actualizar un ítem
  const handleUpdateItem = (index, newDescripcion, newCantidad, newDescuento) => {
    const updatedItems = itemList.map((it, i) => {
      if (i === index) {
        return {
          ...it,
          descripcion: it.descripcion,
          cantidad: newCantidad !== undefined ? Number(newCantidad) : it.cantidad,
          stock: it.stock,
          precio: it.precio,
          codigo: it.codigo,
          porcentajeDescuento: newDescuento !== undefined ? Number(newDescuento) : it.porcentajeDescuento,
        }
      }
      return it
    })

    setItemList(updatedItems)
    showSnackbar("Ítem actualizado", "success")
  }

  // Función para actualizar ítem descontado
  const handleUpdateItemDescontados = (index, newCantidadDevolver) => {
    const updatedItems = [...itemListCanjeables]

    const cantidadDevolverNueva = Number(newCantidadDevolver) || 0

    // Permitir que la cantidad a devolver exceda la cantidad disponible
    // pero esto deshabilitará el botón de generar devolución
    if (cantidadDevolverNueva < 0) {
      showSnackbar("La cantidad a devolver no puede ser negativa", "warning")
      return
    }

    // Actualizamos solo la cantidad a devolver en el ítem específico
    updatedItems[index].cantidadDevolver = cantidadDevolverNueva

    // Actualizamos la lista de ítems
    setItemListCanjeables(updatedItems)

    showSnackbar("Cantidad a devolver actualizada", "success")
  }

  // Función para eliminar ítem
  const handleDeleteItem = (index) => {
    const itemToRemove = itemList[index]
    setPrecioTotal((prevTotal) => prevTotal - getTotalItemConInteres(itemToRemove, itemToRemove.cantidad))
    setCantidadItemsSelect((prevCantidad) => prevCantidad - itemToRemove.cantidad)
    setCantidadItemsInvocados((prevSelect) => prevSelect - 1)
    setItemList(itemList.filter((_, i) => i !== index))

    showSnackbar(`Ítem "${itemToRemove.descripcion}" eliminado`, "info")
  }

  // Función para eliminar todos los ítems
  const handleDeleteAllItems = () => {
    if (itemList.length === 0) {
      showSnackbar("No hay ítems para eliminar", "info")
      return
    }

    setItemList([])
    setPrecioTotal(0)
    setCantidadItemsSelect(0)
    setCantidadItemsInvocados(0)

    showSnackbar("Todos los ítems han sido eliminados", "info")
  }

  // Función para validar si alguna cantidad de devolución excede la cantidad original
  const validarCantidadesDevolucion = () => {
    if (itemListCanjeables.length === 0) return true
    
    return itemListCanjeables.every(item => {
      const cantidadDevolver = item.cantidadDevolver || 0
      const cantidadOriginal = item.cantidad || 0
      return cantidadDevolver <= cantidadOriginal
    })
  }

  // Función para verificar cliente
  const controlarDniIngresadoSiExiste = () => {
    const entidadEncontrada = entidades.find((entidad) => entidad.dniCuitCuil === dniCliente)

    if (entidadEncontrada) {
      setEntidadExistente(entidadEncontrada)
      setAbrirModalEntidadCliente(true)
    } else {
      setEntidadExistente(null)
      setAbrirModalEntidadCliente(true)
    }
  }

  // Función para abrir modal de creación de cliente
  const handleAbrirModalCrearCliente = () => {
    setAbrirModalEntidadCliente(false)
    setAbrirModalCrearCliente(true)
    setIsEditing(false)
  }

  // Función para cerrar modal de creación de cliente
  const handleCerrarModalCrearCliente = () => {
    setAbrirModalCrearCliente(false)
  }

  // Función para abrir modal de modificación de cliente
  const abrirModificarCliente = (entidad) => {
    setEntidadAEditar(entidad)
    setIsEditing(true)
    setAbrirModalCrearCliente(true)
  }

  // Función para manejar teclas en campos de búsqueda
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      if (document.activeElement === buttonRef.current) {
        autocompleteRef.current.focus()
      } else {
        buttonRef.current.focus()
      }
    }
  }

  // Función para manejar teclas y enviar formulario
  const handleKeyDownAndSubmit = (event) => {
    handleKeyDown(event)
    if (event.key === "Enter") {
      handleAddItem()
    }
  }

  // Función para cerrar modal de medio de pago
  const handleCloseModalMedioPago = () => {
    if (Math.abs(cantidaMedioDePagoList - precioTotal) > 0.01) {
      const confirmReset = window.confirm(
        "El total de medios de pago no es igual al precio de venta. ¿Desea reiniciar la selección?",
      )
      if (confirmReset) {
        setMedioDePagoList([])
        setCantidaMedioDePagoList(0)
      } else {
        return
      }
    }
    setOpenModalMedioPago(false)
  }

  // Función para mostrar snackbar
  const showSnackbar = (message, severity = "info") => {
    setSnackbar({
      open: true,
      message,
      severity,
    })
  }

  // Función para mostrar error de validación
  const mostrarErrorValidacion = (errores) => {
    let mensajeDetallado = "No es posible realizar devoluciones por una cantidad mayor a la comprada:\n\n";
    
    errores.forEach((error, index) => {
      mensajeDetallado += `${index + 1}. ${error.descripcion}\n`;
      mensajeDetallado += `   - Cantidad original: ${error.cantidadOriginal}\n`;
      mensajeDetallado += `   - Ya devuelto: ${error.cantidadYaDevuelta}\n`;
      mensajeDetallado += `   - A devolver: ${error.cantidadADevolver}\n`;
      mensajeDetallado += `   - Total a devolver: ${error.totalADevolver}\n`;
      mensajeDetallado += `   - Exceso: ${error.exceso}\n\n`;
    });

    withReactContent(Swal).fire({
      title: "Error de Validación",
      html: `<div style="text-align: left; white-space: pre-line;">${mensajeDetallado}</div>`,
      icon: "error",
      confirmButtonText: "Entendido",
      confirmButtonColor: "#d33",
      width: 600,
    });
  }

  // Función para cerrar snackbar
  const handleCloseSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    })
  }

  // Renderiza el spinner mientras está cargando
  if (loading) {
    return <SpinnerLading />
  }

  // ************************************************************************************************************************************************************
  // ************************************************************************************************************************************************************
  // ************************************************************************************************************************************************************
  // ************************************************************************************************************************************************************
  // ************************************************************************************************************************************************************
  // ************************************************************************************************************************************************************

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#f5f5f5",
        position: "relative",
      }}
    >
      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          p: 2,
          overflow: "auto",
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault()
            handleTransaccionSubmit(true)
          }}
        >
          <Grid container spacing={2} sx={{ padding: "0px !important" }}>
            {/* Left Column - Productos y selección de Cliente */}
            <Grid item xs={12} md={9} sx={{ padding: "0px !important" }}>
              <Card
                elevation={3}
                sx={{
                  mb: 2,
                  borderRadius: 2,
                  padding: "0px !important",
                  backgroundColor: alpha(theme.palette.primary.light, 0.1),
                  mb: 2,
                  gap: 1,
                  p: 1,
                  borderRadius: 1,
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}>
                    <TextField
                      size="small"
                      label="Cliente - DNI / CUIT / CUIL"
                      // value={dniCliente}
                      value={`${idEntidad.descripcion} ${idEntidad.nombre || ''} ${idEntidad.dniCuitCuil}`}
                      onChange={(e) => setDniCliente(e.target.value)}
                      sx={{ flexGrow: 1 }}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Tooltip title="Verificar Cliente">
                      <IconButton color="primary" onClick={controlarDniIngresadoSiExiste}>
                        <PersonAddAltIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={itemTresLetras.map((it) => ({
                        label: it.codigo + " - " + it.descripcion,
                        descripcion: it.descripcion,
                        codigo: it.codigo,
                        id: it.id,
                      }))}
                      value={selectedItem}
                      onChange={(event, newValue) => {
                        setSelectedItem(newValue)
                        if (newValue) {
                          cantidadRef.current.focus()
                        }
                      }}
                      onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                      sx={{ flexGrow: 1 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Buscar producto"
                          inputRef={autocompleteRef}
                          onKeyDown={handleKeyDown}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                <SearchIcon color="action" sx={{ ml: 1, mr: 0.5 }} />
                                {params.InputProps.startAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                    <TextField
                      size="small"
                      label="Cantidad"
                      variant="outlined"
type="number"
                      value={cantidadTransaccionItem}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Permitir vacío para poder borrar
                        if (value === "") {
                          setCantidadTransaccionItem("");
                          return;
                        }
                        // Validar formato: máximo 4 decimales
                        const decimalRegex = /^\d+(\.\d{0,4})?$/;
                        if (decimalRegex.test(value)) {
                          setCantidadTransaccionItem(value);
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value;
                        if (raw === "") {
                          setCantidadTransaccionItem("");
                          return;
                        }
                        const parsed = Number.parseFloat(raw);
                        if (!isNaN(parsed) && parsed > 0) {
                          // Normalizar a máximo 4 decimales
                          const normalized = Math.round(parsed * 10000) / 10000;
                          setCantidadTransaccionItem(normalized.toString());
                        } else {
                          setCantidadTransaccionItem("");
                        }
                      }}
                      inputRef={cantidadRef}
                      onKeyDown={handleKeyDown}
                      inputProps={{
                        step: "0.0001",
                        min: "0.0001",
                      }}                      
                      sx={{ width: 100 }}
                    />
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={usuarios.map((it) => ({
                        label: `${it.usuario} - ${it.nombre || ""} - ${it.apellido || ""}`,
                        nombre: it.nombre,
                        apellido: it.apellido,
                        id: it.id,
                        usuario: it.usuario,
                      }))}
                      value={usuarioSeleccionado}
                      onChange={(event, newValue) => setUsuarioSeleccionado(newValue)}
                      sx={{ width: 250 }}
                      renderInput={(params) => <TextField {...params} label="Vendedor" />}
                    />
                    <Button
                      variant="contained"
                      onClick={handleAddItem}
                      ref={buttonRef}
                      onKeyDown={handleKeyDownAndSubmit}
                      startIcon={<AddShoppingCartIcon />}
                      sx={{ backgroundColor: "#5b5b5f", color: "white" }}
                    >
                      Agregar
                    </Button>
                  </Box>
                </CardContent>
              </Card>

              {/* Tabla de Items Devueltos */}
              <Card elevation={3} sx={{ mb: 2, borderRadius: 2, overflow: "hidden" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: 2,
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    gap: 2,
                  }}
                >
                  <KeyboardReturnIcon />
                  <Typography variant="h6">Items Devueltos</Typography>
                </Box>
                <TableContainer>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Item</StyledTableCell>
                        <StyledTableCell align="right">Cantidad</StyledTableCell>
                        <StyledTableCell align="right">Devolución</StyledTableCell>
                        <StyledTableCell align="right">Precio Unitario</StyledTableCell>
                        <StyledTableCell align="right">Descuento</StyledTableCell>
                        <StyledTableCell align="right">Interés</StyledTableCell>
                        <StyledTableCell align="right">Total</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemListCanjeables.length > 0 ? (
                                                 itemListCanjeables.map((it, index) => (
                           <StyledTableRow 
                             key={index}
                             sx={{
                               backgroundColor: (it.cantidadDevolver || 0) > it.cantidad ? 
                                 alpha(theme.palette.error.main, 0.1) : 'transparent',
                             }}
                           >
                             <TableCell>
                               <Typography variant="body2" fontWeight="medium">
                                 {it.codigo} - {it.descripcion}
                               </Typography>
                             </TableCell>
                             <TableCell align="right">{it.cantidad}</TableCell>
                             <TableCell align="right">
                               <TextField
                                 type="number"
                                 value={cantidadInputsDevueltos[index] ?? ""}
                                 size="small"
                                 onChange={e => {
                                  const value = e.target.value;
                                  // Permitir vacío para poder borrar
                                  if (value === "") {
                                    setCantidadInputsDevueltos(prev => ({
                                      ...prev,
                                      [index]: ""
                                    }));
                                    return;
                                  }
                                  // Validar formato: máximo 4 decimales
                                  const decimalRegex = /^\d+(\.\d{0,4})?$/;
                                  if (decimalRegex.test(value)) {
                                    setCantidadInputsDevueltos(prev => ({
                                      ...prev,
                                      [index]: value
                                    }));
                                  }
                                }}
                                onBlur={(e) => {
                                  const raw = cantidadInputsDevueltos[index] ?? ""
                                  if (raw === "") {
                                    handleUpdateItemDescontados(index, 0);
                                    setCantidadInputsDevueltos(prev => ({
                                      ...prev,
                                      [index]: "0"
                                    }));
                                    return;
                                  }
                                  const parsed = Number.parseFloat(raw);
                                  // si quedó vacío o inválido, forzar 0
                                  const finalValue = isNaN(parsed) || parsed < 0 ? 0 : parsed;
                                  // Normalizar a máximo 4 decimales
                                  const normalized = Math.round(finalValue * 10000) / 10000;
                                  handleUpdateItemDescontados(index, normalized)
                                  // y sincronizas el input string con el valor final
                                  setCantidadInputsDevueltos(prev => ({
                                    ...prev,
                                    [index]: normalized.toString()
                                  }));
                                }}
                                inputProps={{
                                  step: "0.0001",
                                  min: "0.0001",
                                }}
                                sx={{
                                   width: 80,
                                   "& .MuiInputBase-root": {
                                     borderRadius: 1,
                                   },
                                 }}
                                 InputProps={{
                                   endAdornment:
                                     (it.cantidadDevolver || 0) > it.cantidad ? (
                                       <Tooltip title="Cantidad de devolución excede la cantidad original">
                                         <ErrorOutlineIcon
                                           sx={{
                                             color: theme.palette.error.main,
                                             cursor: "pointer",
                                           }}
                                         />
                                       </Tooltip>
                                     ) : null,
                                 }}
                               />
                             </TableCell>
                            <TableCell align="right">
                              {new Intl.NumberFormat("es-AR", {
                                style: "currency",
                                currency: "ARS",
                              }).format(it.precio)}
                            </TableCell>
                            <TableCell align="right">{it.porcentajeDescuento || 0}%</TableCell>
                            <TableCell align="right">{it.porcentajeInteres || 0}%</TableCell>
                            <TableCell align="right">
                              <Typography fontWeight="medium">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(getTotalItemConInteres(it, getCantidadReferenciaDevolucion(it)))}
                              </Typography>
                            </TableCell>
                          </StyledTableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                            <Typography variant="body1" color="text.secondary">
                              No hay productos para devolver
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>

              {/* Tabla de Items Canjeados */}
              <Card elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: 2,
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    gap: 2,
                  }}
                >
                  <SwapHorizIcon />
                  <Typography variant="h6">Items Canjeados</Typography>
                </Box>
                <TableContainer>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Item</StyledTableCell>
                        <StyledTableCell align="right">Cantidad</StyledTableCell>
                        <StyledTableCell align="right">Stock</StyledTableCell>
                        <StyledTableCell align="right">Precio Unitario</StyledTableCell>
                        <StyledTableCell align="right">Descuento</StyledTableCell>
                        <StyledTableCell align="right">Interés</StyledTableCell>
                        <StyledTableCell align="right">Total</StyledTableCell>
                        <StyledTableCell align="right">Acciones</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemList.length > 0 ? (
                        itemList.map((it, index) => (
                          <StyledTableRow key={index}>
                            <TableCell>
                              <Typography variant="body2" fontWeight="medium">
                                {it.codigo} - {it.descripcion}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <TextField
                                type="number"
                                value={cantidadInputs[index] ?? ""}
                                size="small"
                                onChange={e => {
                                   const value = e.target.value;
                                  // Permitir vacío para poder borrar
                                  if (value === "") {
                                    setCantidadInputs(prev => ({
                                      ...prev,
                                      [index]: ""
                                    }));
                                    return;
                                  }
                                  // Validar formato: máximo 4 decimales
                                  const decimalRegex = /^\d+(\.\d{0,4})?$/;
                                  if (decimalRegex.test(value)) {
                                    setCantidadInputs(prev => ({
                                      ...prev,
                                      [index]: value
                                    }));
                                  }
                                }}
                                onBlur={() => {
                                  const raw = cantidadInputs[index] ?? ""
                                  if (raw === "") {
                                    const finalValue = itemList[index].cantidad;
                                    handleUpdateItem(
                                      index,
                                      itemList[index].descripcion,
                                      finalValue,
                                      itemList[index].descuento
                                    );
                                    setCantidadInputs(prev => ({
                                      ...prev,
                                      [index]: finalValue.toString()
                                    }));
                                    return;
                                  }
                                  const parsed = Number.parseFloat(raw);
                                  // si quedó vacío o inválido, restituir el anterior
                                  const finalValue = isNaN(parsed) || parsed <= 0 ? itemList[index].cantidad : parsed;
                                  // Normalizar a máximo 4 decimales
                                  const normalized = Math.round(finalValue * 10000) / 10000;
                                  handleUpdateItem(
                                    index,
                                    itemList[index].descripcion,
                                    normalized,
                                    itemList[index].descuento
                                  );
                                  // y sincronizas el input string con el valor final
                                  setCantidadInputs(prev => ({
                                    ...prev,
                                    [index]: normalized.toString()
                                  }));
                                }}
                                inputProps={{
                                  step: "0.0001",
                                  min: "0.0001",
                                }}
                                sx={{
                                  width: 80,
                                  "& .MuiInputBase-root": {
                                    borderRadius: 1,
                                  },
                                }}
                                InputProps={{
                                  endAdornment:
                                    it.cantidad > it.stock ? (
                                      <Tooltip title="Cantidad mayor a stock">
                                        <ErrorOutlineIcon
                                          sx={{
                                            color: theme.palette.error.main,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : null,
                                }}
                              />
                            </TableCell>
                            <TableCell align="right">{it.stock}</TableCell>
                            {/* PRECIO UNITARIO */}
                            <TableCell align="right">
                              {new Intl.NumberFormat("es-AR", {
                                style: "currency",
                                currency: "ARS",
                              }).format(it.precio)}
                            </TableCell>
                            <TableCell align="right">
                              <TextField
                                type="number"
                                value={it.porcentajeDescuento || 0}
                                size="small"
                                onChange={(e) => handleUpdateItem(index, it.descripcion, it.cantidad, e.target.value)}
                                sx={{ width: 80 }}
                                InputProps={{ endAdornment: <span>%</span> }}
                              />
                            </TableCell>
                            <TableCell align="right">{it.porcentajeInteres || 0}%</TableCell>
                            <TableCell align="right">
                              <Typography fontWeight="medium">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(getTotalItemConInteres(it, it.cantidad))}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip title="Eliminar ítem">
                                <IconButton color="error" size="small" onClick={() => handleDeleteItem(index)}>
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </StyledTableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                            <Typography variant="body1" color="text.secondary">
                              No hay productos agregados para canje
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                              Busque y agregue productos para comenzar el canje
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={8} align="right">
                          <Button
                            variant="outlined"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={handleDeleteAllItems}
                            disabled={itemList.length === 0}
                            sx={{ mt: 1, mb: 1 }}
                          >
                            Eliminar todos
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Card>

              {/* Contador de ítems */}
              {itemList.length > 0 && (
                <Card
                  elevation={3}
                  sx={{
                    mt: 2,
                    p: 2,
                    borderRadius: 2,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      ITEMS:
                    </Typography>
                    <Typography variant="subtitle1">{itemList.length}</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      CANTIDAD ITEMS:
                    </Typography>
                    <Typography variant="subtitle1">
                      {itemList.reduce((total, item) => total + item.cantidad, 0)}
                    </Typography>
                  </Box>
                </Card>
              )}
            </Grid>

            {/* Right Column - Resumen y Medios de Pago */}
            <Grid item xs={12} md={3}>
              {/* Ubicación y Negocio */}
              <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                    <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 147, 14)" }} />
                    Ubicación y Negocio
                  </Typography>
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={ubicaciones.map((it) => ({
                      id: it.id,
                      label: it.descripcion,
                    }))}
                    value={selectedUbicacion}
                    onChange={(event, newValue) => {
                      setSelectedUbicacion(newValue)
                    }}
                    readOnly
                    disabled
                    renderInput={(params) => <TextField {...params} label="Ubicación Actual" sx={{ mb: 2 }} />}
                  />
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={negocios.map((it) => ({
                      id: it.id,
                      label: it.descripcion,
                    }))}
                    readOnly
                    disabled
                    value={selectedNegocio}
                    onChange={(event, newValue) => {
                      setSelectedNegocio(newValue)
                    }}
                    renderInput={(params) => <TextField {...params} label="Negocio Actual" />}
                  />
                </CardContent>
              </Card>

              {/* Resumen de Devolución/Canje */}
              <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                    <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 147, 14)" }} />
                    Resumen de Devolución/Canje
                  </Typography>

                  <Box
                    sx={{
                      backgroundColor: alpha(theme.palette.primary.light, 0.1),
                      p: 2,
                      borderRadius: 1,
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography variant="body1">Total Venta:</Typography>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color={precioTotalDevolucion === 0 ? "text.secondary" : "error.main"}
                      >
                        {new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(precioTotalDevolucion)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography variant="body1">Total Devolución:</Typography>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color={precioTotalDevolucionDiferencia === 0 ? "text.secondary" : "error.main"}
                      >
                        {new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(precioTotalDevolucionDiferencia * -1)}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography variant="body1">Monto Canje:</Typography>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        color={precioTotal === 0 ? "text.secondary" : "error.main"}
                      >
                        {new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(precioTotal)}
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                      <Typography variant="h6">NETO:</Typography>
                      <Typography variant="h6" color="rgb(244, 147, 14)" fontWeight="bold">
                        {new Intl.NumberFormat("es-AR", {
                          style: "currency",
                          currency: "ARS",
                        }).format(precioTotalNetoDevolucion)}
                      </Typography>
                    </Box>
                  </Box>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={aplicarDescuento}
                        onChange={(e) => setAplicarDescuento(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Aplicar Descuento"
                  />

                  <Collapse in={aplicarDescuento} timeout={300}>
                    <Box sx={{ mt: 1, mb: 1 }}>
                      <TextField
                        label="Descuento en Valor ($)"
                        type="number"
                        value={tempValorDescuento}
                        onChange={(e) => setTempValorDescuento(e.target.value)}
                        onBlur={applyDiscounts}
                        InputProps={{
                          inputProps: { step: 0.01 },
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        fullWidth
                        size="small"
                        sx={{ mb: 1 }}
                      />
                      <TextField
                        label="Descuento en Porcentaje (%)"
                        type="number"
                        value={tempPorcentajeDescuento}
                        onChange={(e) => setTempPorcentajeDescuento(e.target.value)}
                        onBlur={applyDiscounts}
                        InputProps={{
                          inputProps: { step: 0.01, min: 0, max: 100 },
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        fullWidth
                        size="small"
                      />
                    </Box>
                  </Collapse>
                </CardContent>
              </Card>

              {/* Medios de Pago */}
              <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                    <PaymentsIcon sx={{ mr: 1, color: "rgb(244, 147, 14)" }} />
                    Medios de Pago
                  </Typography>

                  <Box sx={{ mb: 2 }}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      disablePortal
                      options={
                        precioTotalNetoDevolucion < 0
                          ? tipoMedioDePago.filter((option) => option.id === 1 || option.id === 5)
                          : tipoMedioDePago
                      }
                      getOptionLabel={(option) => option.descripcion || ""}
                      value={selectedTipoMedioDePago}
                      onChange={(event, newValue) => {
                        if (precioTotalNetoDevolucion < 0 && newValue && newValue.id !== 1 && newValue.id !== 5) {
                          showSnackbar("Solo se permite el medio de pago con ID 1 o 5", "warning")
                          setSelectedTipoMedioDePago(null)
                        } else {
                          setSelectedTipoMedioDePago(newValue)
                        }
                      }}
                      renderInput={(params) => <TextField {...params} label="Tipo de medio de pago" />}
                    />

                    {mostrarButtonModalMedioPago && (
                      <Button
                        variant="outlined"
                        startIcon={<VisibilityIcon />}
                        onClick={handleAbrirModalMedioDePago}
                        fullWidth
                        sx={{ mt: 1 }}
                      >
                        Ver medios de pago seleccionados
                      </Button>
                    )}

                    <Collapse in={openCollapse}>
                      <Box sx={{ mt: 2 }}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disablePortal
                          options={medioDePagoIdTipoEspecifico}
                          getOptionLabel={(option) => option.descripcion || ""}
                          value={selectedMedioDePago || ""}
                          onChange={(event, newValue) => {
                            setSelectedMedioDePago(newValue)
                          }}
                          renderInput={(params) => <TextField {...params} label="Medio de pago específico" />}
                        />
                      </Box>
                    </Collapse>
                  </Box>

                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    size="large"
                    startIcon={<PointOfSaleIcon />}
                    disabled={!validarCantidadesDevolucion()}
                    sx={{
                      py: 1.5,
                      borderRadius: 2,
                      fontWeight: "bold",
                      boxShadow: 3,
                      backgroundColor: validarCantidadesDevolucion() ? "green" : "grey",
                      color: "white",
                    }}
                  >
                    GENERAR CANJE/DEVOLUCIÓN
                  </Button>
                  
                  {!validarCantidadesDevolucion() && (
                    <Alert 
                      severity="warning" 
                      sx={{ mt: 1 }}
                      icon={<ErrorOutlineIcon />}
                    >
                      No se puede generar la devolución. Una o más cantidades de devolución exceden la cantidad original del producto. Revise las filas marcadas en rojo.
                    </Alert>
                  )}

                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleDeleteAllItems}
                    fullWidth
                    size="large"
                    startIcon={<DeleteIcon />}
                    sx={{ mt: 2, py: 1.5, borderRadius: 2 }}
                  >
                    ELIMINAR ÍTEMS
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Box>

      {/* Modales */}
      <ModalEntidadCliente
        open={abrirModalEntidadCliente}
        handleClose={() => setAbrirModalEntidadCliente(false)}
        esClienteExistente={!!entidadExistente}
        entidad={entidadExistente}
        abrirCrearCliente={handleAbrirModalCrearCliente}
        crearVentaIgualmente={crearVentaIgualmente}
        abrirModificarCliente={abrirModificarCliente}
        deDondeViene="DEVOLUCION / CANJE"
      />

      <CrearEntidadClienteModalComponent
        open={abrirModalCrearCliente}
        handleClose={handleCerrarModalCrearCliente}
        entidad={entidadAEditar}
        isEditing={isEditing}
      />

      {/* Modal de Medio de Pago */}
      <Modal open={openModalMedioPago} onClose={handleCloseModalMedioPago}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}>
              <PaymentsIcon sx={{ mr: 1, color: "rgb(244, 147, 14)" }} />
              Selección de Medios de Pago
            </Typography>
            <IconButton onClick={handleCloseModalMedioPago} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                size="small"
                fullWidth
                options={tipoMedioDePago}
                getOptionLabel={(option) => option.descripcion || ""}
                value={modalTipoMedioDePagoSeleccionado}
                onChange={(event, newValue) => setModalTipoMedioDePagoSeleccionado(newValue)}
                renderInput={(params) => <TextField {...params} label="Tipo de medio de pago" />}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Autocomplete
                size="small"
                fullWidth
                options={medioDePagoIdTipoEspecifico.map((it) => ({
                  label: it.descripcion,
                  id: it.id,
                }))}
                value={modalMedioDePagoSeleccionado}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setModalMedioDePagoSeleccionado(newValue.label)
                    setModalMedioDePagoSeleccionadoID(newValue.id)
                  } else {
                    setModalMedioDePagoSeleccionado("")
                    setModalMedioDePagoSeleccionadoID(null)
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Medio de Pago" />}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1 }}>
            <TextField
              label="Monto a pagar"
              size="small"
              fullWidth
              value={modalMedioDePagoCantidad || ""}
              onChange={(e) => setModalMedioDePagoCantidad(e.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
            <Button variant="contained" onClick={handleAddNuevoMedioDePago} startIcon={<AddCircleOutlineIcon />}>
              Agregar
            </Button>
          </Box>

          <Card variant="outlined" sx={{ mb: 3, bgcolor: alpha(theme.palette.primary.light, 0.05) }}>
            <CardContent>
              <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
                Resumen de Pagos
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body1">Total a pagar:</Typography>
                <Typography variant="body1" fontWeight="bold">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(precioTotal)}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body1">Total medios de pago:</Typography>
                <Typography variant="body1" fontWeight="bold">
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(cantidaMedioDePagoList)}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body1">Diferencia:</Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color={(Math.abs(cantidaMedioDePagoList - precioTotal) > 0.01) ? "success.main" : "error.main"}
                >
                  {new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                  }).format(precioTotal - cantidaMedioDePagoList)}
                </Typography>
              </Box>

              {(Math.abs(cantidaMedioDePagoList - precioTotal) > 0.01) && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                  El total de medios de pago debe ser igual al total a pagar
                </Alert>
              )}
            </CardContent>
          </Card>

          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Medios de Pago Seleccionados
          </Typography>

          {medioDePagoList.length > 0 ? (
            <Box sx={{ maxHeight: 200, overflow: "auto", mb: 2 }}>
              {medioDePagoList.map((it, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    p: 1,
                    mb: 1,
                    borderRadius: 1,
                    bgcolor: alpha(theme.palette.background.default, 0.7),
                    border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
                  }}
                >
                  <Typography variant="body2">{it.descripcion}</Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(it.monto)}
                    </Typography>
                    <IconButton size="small" color="error" onClick={() => handleDeleteMedioDePago(index, it.monto)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: "center", py: 2 }}>
              No hay medios de pago seleccionados
            </Typography>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={handleCloseModalMedioPago}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleCloseModalMedioPago}
              disabled={(Math.abs(cantidaMedioDePagoList - precioTotal) > 0.01)}
            >
              Confirmar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal de Factura */}
      {openModal && (
        <ModalFacturaComponent
          open={openModal}
          handleClose={handleCloseModal}
          transaccionData={transaccionData}
          impuestos={impuestos}
          itemsTransaccion={itemsTransaccion}
          entidadParaFactura={entidadFactura}
          usuarioParaFactura={usuarioSeleccionado}
          tipoDeFactura={true}
          deDondeViene={"devolucion"}
        />
      )}

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default GestionDevolucionCanjeVentaComponent
